export default "https://ssr-releases-cdn.paperlesspost.com/_next/static/video/DesktopHeroPoster-9d9f225c2aea27008683afffa624af5f.jpg";